import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=6aaa7f5e"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPage.vue?vue&type=style&index=0&id=6aaa7f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports